import { styled } from "@linaria/react";

const FormFieldError = styled.div`
  color: red;
  min-height: 1.5rem;
  font-size: 0.75rem;
  transition: 0.6s;
  transition-delay: 0.4s;
  padding-left: 0.75rem;
  &::first-letter {
    text-transform: capitalize;
  }
`;
export const FormFieldErrorStyle = { FormFieldError };
